<template>
  <div>
    <el-drawer class="activity-drawer" :title="isEdit ? '修改' : '新增'" direction="rtl" :visible="value" size="800px"
      :before-close="handleClose">
      <template #title>
        <div class="activity-drawer__header">
          {{ isEdit ? '修改' : '新增' }}

          <el-input size="small" v-model="parseString" style="width: 200px;margin: 0 10px;" v-if="!isEdit"></el-input>
          <el-button type="primary" size="small" v-if="!isEdit" @click="parseActivity">粘贴</el-button>
        </div>
      </template>
      <div class="activity-drawer__contain">
        <div class="activity-drawer__main">
          <div class="steps">
            <div class="steps__item" :class="{ active: activeIndex === 1 }" @click="activeIndex = 1">基础配置</div>
            <el-divider direction="vertical"></el-divider>
            <div class="steps__item" :class="{ active: activeIndex === 2 }" @click="activeIndex = 2">文件上传</div>
            <el-divider direction="vertical"></el-divider>
            <div class="steps__item" :class="{ active: activeIndex === 3 }" @click="activeIndex = 3">颜色配置</div>
          </div>
          <el-form ref="form1" :model="formData" label-width="120px" v-show="activeIndex === 1">
            <el-form-item label="活动时间">
              <el-col :span="11">
                <el-date-picker type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="formData.startTime" style="width: 100%;"></el-date-picker>
              </el-col>
              <el-col class="line" :span="2" style="text-align: center;">-</el-col>
              <el-col :span="11">
                <el-date-picker type="datetime" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="formData.endTime" style="width: 100%;"></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="formData.name"></el-input>
            </el-form-item>
            <el-form-item label="活动描述" prop="eventDesc">
              <el-input type="textarea" :rows="2" placeholder="请输入描述" v-model="formData.eventDesc">
              </el-input>
            </el-form-item>
            <el-form-item label="活动使用时区" prop="name">
              <el-select filterable v-model="formData.zoneOffset" placeholder="请选择">
                <el-option v-for="item in searchConst.zoneOffset" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="日期格式化格式" prop="dateFormat">
              <el-select filterable v-model="formData.dateFormat" placeholder="请选择">
                <el-option v-for="item in searchConst.dateFormat" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道列表" prop="channelSet">
              <el-select filterable v-model="formData.channelSet" placeholder="请选择渠道列表(为空则不限制)" multiple>
                <el-option v-for="item in searchConst.channelList" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="国家列表" prop="name">
              <el-select filterable v-model="formData.countryCodeSet" placeholder="请选择国家列表(为空则不限制)" multiple>
                <el-option v-for="item in searchConst.countryList" :key="item.countryCode" :label="item.country"
                  :value="item.countryCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="参与群体" prop="name">
              <el-select filterable v-model="formData.joinModeInfo.mode" placeholder="请选择">
                <el-option v-for="item in searchConst.joinMode" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="conditions-tabs">
              <el-row :gutter="20" v-for="(conditionObj, ind) in formData.joinModeInfo.conditions">
                <el-col :span="6">
                  <el-select filterable v-model="conditionObj.condition" placeholder="请选择">
                    <el-option v-for="item in searchConst.relation" :key="item.value" :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6">
                  <el-select filterable v-model="conditionObj.mode" placeholder="请选择" @change="() => {
                    conditionObj.value = null
                  }">
                    <el-option v-for="item in searchConst.conditionMode" :key="item.value" :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="5">
                  <el-select filterable v-model="conditionObj.relation" placeholder="请选择">
                    <el-option v-for="(item, ind) in searchConst.condition" :key="ind" :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>

                <el-col :span="5">
                  <el-date-picker v-if="conditionObj.mode == 1" v-model="conditionObj.value" value-format="timestamp"
                    type="datetime" :disabled="!formData.zoneOffset" placeholder="选择日期时间">
                  </el-date-picker>
                  <el-select v-else-if="conditionObj.mode == 3" v-model="conditionObj.value" placeholder="请选择">
                    <el-option label="男" value="1">
                    </el-option>
                    <el-option label="女" value="2">
                    </el-option>
                  </el-select>
                  <el-select v-else-if="conditionObj.mode == 2" v-model="conditionObj.value" placeholder="请选择">
                    <el-option label="用户" value="1">
                    </el-option>
                    <el-option label="主播" value="2">
                    </el-option>
                  </el-select>
                  <el-input v-else-if="conditionObj.mode == 4" v-model="conditionObj.value"
                    placeholder="贵族是1~6"></el-input>
                  <el-input v-else-if="conditionObj.mode == 6" v-model="conditionObj.value"
                    placeholder="用英文,分割"></el-input>
                  <el-select v-else-if="conditionObj.mode == 7" v-model="conditionObj.value" placeholder="请选择">
                    <el-option label="是" value="true">
                    </el-option>
                    <el-option label="否" value="false">
                    </el-option>
                  </el-select>
                  <el-input v-else v-model="conditionObj.value"></el-input>
                </el-col>
                <el-col :span="2">
                  <div class="ico-box">
                    <i class="el-icon-delete-solid ico" @click="delConditions(ind)"></i>
                  </div>
                </el-col>
              </el-row>
              <div class="btn-flex" v-if="formData.joinModeInfo.mode == 1">
                <el-button size="small" type="primary" plain @click="addConditions">新增条件</el-button>
              </div>
            </div>
            <el-form-item label="禁止参与用户" prop="notJoinRidSet">
              <el-input placeholder="输入rid(使用,隔开)" v-model="formData.notJoinRidSet"></el-input>
            </el-form-item>
            <el-form-item label="活动方式" prop="mode">
              <el-select filterable v-model="formData.eventModeInfo.mode" placeholder="请选择">
                <el-option v-for="item in searchConst.eventMode" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <template v-if="formData.eventModeInfo.mode == 1">
              <el-form-item label="榜单类型" prop="name" multiple>
                <el-select filterable v-model="formData.rankType" placeholder="请选择" multiple>
                  <el-option v-for="item in searchConst.rankType" :key="item.value" :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="榜单人数" prop="eventModeInfo.modeRankInfo.rankShowNum">
                <el-input v-model.number="formData.eventModeInfo.modeRankInfo.rankShowNum"></el-input>
              </el-form-item>
              <el-form-item label="礼物id列表/游戏事件码列表" v-if="isShowGift(formData.rankType)">
                <el-button type="primary" size="small" @click="openGiftDialog">打开多礼物id列表/多游戏的事件码列表</el-button>
                <span style="margin-left: 10px; color: #999;">已选择 {{
                  formData.eventModeInfo.modeRankInfo.dataIdSet.length
                  }}
                  个礼物id/游戏事件码</span>
              </el-form-item>
            </template>
          </el-form>
          <el-form ref="form2" :model="formData" label-width="160px" v-show="activeIndex === 2">
            <el-form-item label="规则按钮图" prop="pageInfo.rulePage.ruleButtonImg">
              <UploadSingleImg v-model="formData.pageInfo.rulePage.ruleButtonImg" :on-upload="uploadFile" />
            </el-form-item>
            <el-form-item label="规则内容图" prop="pageInfo.rulePage.ruleBodyImg">
              <UploadSingleImg v-model="formData.pageInfo.rulePage.ruleBodyImg" :on-upload="uploadFile" />
            </el-form-item>
            <el-form-item label="规则内容" prop="pageInfo.rulePage.ruleBodyStr">
              <el-input type="textarea" :rows="2" placeholder="请输入描述" v-model="formData.pageInfo.rulePage.ruleBodyStr">
              </el-input>
            </el-form-item>
            <el-form-item label="活动头图" prop="pageInfo.headImg">
              <UploadSingleImg v-model="formData.pageInfo.headImg" :on-upload="uploadFile" />
            </el-form-item>
            <el-form-item label="活动头部背景图" prop="pageInfo.headBackgroundImg">
              <UploadSingleImg v-model="formData.pageInfo.headBackgroundImg" :on-upload="uploadFile" />
            </el-form-item>


            <el-form-item label="活动方式头图" prop="pageInfo.modelHeadImg">
              <UploadSingleImg v-model="formData.pageInfo.modelHeadImg" :on-upload="uploadFile" />
            </el-form-item>
            <el-form-item label="兑换按钮图" prop="pageInfo.claimButtonImg">
              <UploadSingleImg v-model="formData.pageInfo.claimButtonImg" :on-upload="uploadFile" />
            </el-form-item>
            <el-form-item label="兑换弹窗头部图" prop="pageInfo.claimPopHeadImg">
              <UploadSingleImg v-model="formData.pageInfo.claimPopHeadImg" :on-upload="uploadFile" />
            </el-form-item>
            <el-form-item label="兑换弹窗关闭按钮图" prop="pageInfo.claimPopCancelButtonImg">
              <UploadSingleImg v-model="formData.pageInfo.claimPopCancelButtonImg" :on-upload="uploadFile" />
            </el-form-item>
            <el-form-item label="参与方式说明" prop="pageInfo.joinTip">
              <el-input v-model="formData.pageInfo.joinTip" type="textarea" :rows="2"></el-input>
            </el-form-item>
            <el-form-item label="参与方式文案颜色" prop="pageInfo.joinTipColor">
              <el-input placeholder="请输入颜色" v-model="formData.pageInfo.joinTipColor">
                <template slot="suffix">
                  <div class="color-suffix">
                    <el-color-picker v-model="formData.pageInfo.joinTipColor" show-alpha size="small"></el-color-picker>
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="不参与活动用户提示" prop="pageInfo.notJoinTip">
              <el-input v-model="formData.pageInfo.notJoinTip" type="textarea" :rows="2"></el-input>
            </el-form-item>
            <el-form-item label="不参与活动用户提示文案颜色" prop="pageInfo.notJoinTipColor">
              <el-input placeholder="请输入颜色" v-model="formData.pageInfo.notJoinTipColor">
                <template slot="suffix">
                  <div class="color-suffix">
                    <el-color-picker v-model="formData.pageInfo.notJoinTipColor" show-alpha
                      size="small"></el-color-picker>
                  </div>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <el-form ref="form3" :model="formData" label-width="160px" v-show="activeIndex === 3">
            <el-form-item :label="item.label" :prop="item.value" v-for="item in colorLabels">
              <el-input placeholder="请输入颜色" v-model="formData.pageInfo.backgroundColors[item.value]">
                <template slot="suffix">
                  <div class="color-suffix">
                    <el-color-picker v-model="formData.pageInfo.backgroundColors[item.value]" show-alpha
                      size="small"></el-color-picker>
                  </div>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <footer class="activity-drawer__footer">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </footer>
      </div>

    </el-drawer>
    <!-- 礼物列表弹窗 -->
    <el-dialog title="礼物列表/或游戏事件码管理" :visible.sync="giftDialogVisible" width="40%">
      <div class="gift-dialog">
        <!-- 搜索和添加区域 -->
        <div class="gift-dialog__header">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-input v-model="searchGiftId" placeholder="请输入礼物ID或游戏事件码进行搜索" @keyup.enter="searchGift" clearable>
                <el-button slot="append" icon="el-icon-search" @click="searchGift"></el-button>
              </el-input>
            </el-col>
            <el-col :span="12">
              <el-input v-model="newGiftId" placeholder="请输入礼物ID或游戏事件码" @keyup.enter="addGiftId" type="number">
                <el-button slot="append" type="primary" @click="addGiftId">添加</el-button>
              </el-input>
            </el-col>
          </el-row>
        </div>

        <!-- 礼物列表表格 -->
        <div class="gift-dialog__table">
          <el-table :data="filteredGiftList" height="300" border>
            <el-table-column prop="id" label="礼物ID或游戏事件码" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" icon="el-icon-delete"
                  @click="removeGiftId(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 统计信息 -->
        <div class="gift-dialog__info">
          <span>共 {{ tempGiftIdList.length }} 个礼物或游戏事件码</span>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelGiftDialog">取消</el-button>
        <el-button type="primary" @click="confirmGiftDialog">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg'
import { getChannelList, getCountryList } from '@/api/baseRequest'
import { addActivityReq, editActivityReq } from '@/api/activityModelRequest'
import { getConstList } from '@/api/constRequest'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)


export default {
  components: {
    UploadSingleImg
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },

    data: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      parseString: '',
      activeIndex: 1,
      // 礼物弹窗相关数据
      giftDialogVisible: false,
      newGiftId: '',
      searchGiftId: '',
      tempGiftIdList: [], // 临时存储礼物ID列表
      formData: {
        notJoinRidSet: '',
        eventModeInfo: {
          mode: '',
          modeRankInfo: {
            rankShowNum: 0,
            dataIdSet: []
          }
        },
        joinModeInfo: {
          mode: '',
          conditions: []
        },
        dateFormat: '',
        zoneOffset: '',
        rankType: [],
        pageInfo: {
          rulePage: {
            ruleButtonImg: '',
            ruleBodyImg: '',
            ruleBodyStr: ''
          },
          headImg: '',
          headBackgroundImg: '',
          modelHeadImg: '',
          claimButtonImg: '',
          claimPopHeadImg: '',
          claimPopCancelButtonImg: '',
          notJoinTip: '',
          notJoinTipColor: '',
          joinTip: '',
          joinTipColor: '',
          backgroundColors: {
            modeBodyBorderColor: '',
            rankDownColor: '',
            rankDownTextColor: '',
            modeBackgroundColor: '',
            modeTextColor: '',
            claimPopColor: '',
            claimPopTextColor: '',
            globalBackgroundColor: ''
          }
        }
      },
      searchConst: {
        conditionMode: [],
        condition: [],
        relation: [],
        zoneOffset: [],
        dateFormat: [],
        channelList: [],
        countryList: [],
        joinMode: [],
        eventMode: [],
        rankType: []
      },
      colorLabels: [
        { label: '活动方式内容边框色', value: 'modeBodyBorderColor' },
        { label: '榜单底部色号', value: 'rankDownColor' },
        { label: '榜单底部文字色号', value: 'rankDownTextColor' },
        { label: '活动方式背景颜色', value: 'modeBackgroundColor' },
        { label: '活动方式文字颜色', value: 'modeTextColor' },
        { label: '兑换成功弹窗背景色', value: 'claimPopColor' },
        { label: '兑换成功弹窗文字色', value: 'claimPopTextColor' },
        { label: '全局背景色', value: 'globalBackgroundColor' },
      ]
    }
  },
  computed: {
    // 过滤后的礼物列表
    filteredGiftList() {
      if (!this.searchGiftId) {
        return this.tempGiftIdList.map(id => ({ id }))
      }
      return this.tempGiftIdList
        .filter(id => id.toString().includes(this.searchGiftId))
        .map(id => ({ id }))
    }
  },
  watch: {
    isEdit(val) {
      this.parseString = ''
      if (val) {
        this.updateFormData()
      } else {
        this.resetFormData()
      }
    },
    // 监听data属性的变化
    data: {
      handler(newVal) {
        if (this.isEdit && newVal) {
          this.updateFormData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 时区转换方法：将本地时间转换为指定时区的时间戳
    convertToTargetTimezone(timestamp, zoneOffset) {
      if (!timestamp || !zoneOffset) return timestamp

      // 将时间戳转换为本地时间
      const localTime = dayjs(timestamp * 1000)

      // 解析时区偏移量，格式如 "+08:00"
      const offsetHours = parseInt(zoneOffset.substring(1, 3))
      const offsetMinutes = parseInt(zoneOffset.substring(4, 6))
      const isNegative = zoneOffset.startsWith('-')

      // 创建目标时区字符串
      const targetTimezone = `UTC${isNegative ? '-' : '+'}${offsetHours.toString().padStart(2, '0')}:${offsetMinutes.toString().padStart(2, '0')}`

      // 转换到目标时区
      const targetTime = localTime.tz(targetTimezone)

      // 返回秒级时间戳
      return Math.floor(targetTime.valueOf() / 1000)
    },
    // 深拷贝函数
    deepClone(obj) {
      if (obj === null || typeof obj !== 'object') return obj
      if (obj instanceof Date) return new Date(obj)
      if (obj instanceof Array) return obj.map(item => this.deepClone(item))
      if (typeof obj === 'object') {
        const clonedObj = {}
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            clonedObj[key] = this.deepClone(obj[key])
          }
        }
        return clonedObj
      }
    },
    // 更新表单数据
    updateFormData() {
      if (this.data) {
        this.formData = this.deepClone(this.data)
        // 确保notJoinRidSet是字符串类型
        if (Array.isArray(this.formData.notJoinRidSet)) {
          this.formData.notJoinRidSet = this.formData.notJoinRidSet.join(',')
        } else if (this.formData.notJoinRidSet === null || this.formData.notJoinRidSet === undefined) {
          this.formData.notJoinRidSet = ''
        } else {
          this.formData.notJoinRidSet = String(this.formData.notJoinRidSet)
        }
      }
    },
    // 重置表单数据
    resetFormData() {
      this.formData = this.deepClone(this.$options.data().formData)
      // 确保notJoinRidSet是字符串类型
      if (this.formData.notJoinRidSet === null || this.formData.notJoinRidSet === undefined) {
        this.formData.notJoinRidSet = ''
      }
    },
    // 判读是否展示礼物id
    isShowGift(arry) {
      if (arry.length <= 0) return false

      return arry.every(item => [1008, 1010, 1011, 1012, 1015, 1016].includes(item))
    },
    // 打开礼物弹窗
    openGiftDialog() {
      this.giftDialogVisible = true
      // 复制当前的礼物ID列表到临时列表
      this.tempGiftIdList = [...this.formData.eventModeInfo.modeRankInfo.dataIdSet]
      this.newGiftId = ''
      this.searchGiftId = ''
    },
    // 添加礼物ID
    addGiftId() {
      if (!this.newGiftId) {
        this.$message.warning('请输入礼物ID')
        return
      }
      const giftId = parseInt(this.newGiftId)
      if (isNaN(giftId) || giftId <= 0) {
        this.$message.error('请输入有效的礼物ID（正整数）')
        return
      }
      if (this.tempGiftIdList.includes(giftId)) {
        this.$message.warning('该礼物ID已存在，不能重复添加')
        return
      }
      this.tempGiftIdList.push(giftId)
      this.newGiftId = ''
      this.$message.success('添加成功')
    },
    // 删除礼物ID
    removeGiftId(index) {
      // 需要根据过滤后的列表找到实际的索引
      const giftId = this.filteredGiftList[index].id
      const realIndex = this.tempGiftIdList.indexOf(giftId)
      if (realIndex > -1) {
        this.tempGiftIdList.splice(realIndex, 1)
        this.$message.success('删除成功')
      }
    },
    // 搜索礼物
    searchGift() {
      // 搜索功能通过computed属性filteredGiftList自动实现
    },
    // 确认礼物选择
    confirmGiftDialog() {
      this.formData.eventModeInfo.modeRankInfo.dataIdSet = [...this.tempGiftIdList]
      this.giftDialogVisible = false
      this.$message.success(`已选择 ${this.tempGiftIdList.length} 个礼物`)
    },
    // 取消礼物选择
    cancelGiftDialog() {
      this.giftDialogVisible = false
      // 清空临时数据
      this.tempGiftIdList = []
      this.newGiftId = ''
      this.searchGiftId = ''
    },
    async handleSubmit() {
      let res = null
      if (this.formData.notJoinRidSet) {
        if (this.formData.notJoinRidSet.includes(',')) {
          this.formData.notJoinRidSet = this.formData.notJoinRidSet.split(',')
          this.formData.notJoinRidSet = this.formData.notJoinRidSet.map(item => +item)
        } else {
          this.formData.notJoinRidSet = [+this.formData.notJoinRidSet]
        }
      } else {
        this.formData.notJoinRidSet = []
      }

      if (
        this.formData.joinModeInfo.conditions.length > 0
      ) {
        this.formData.joinModeInfo.conditions.forEach(item => {
          if (item.mode === 1) {
            // item.value = this.convertToTargetTimezone(item.value, this.formData.zoneOffset)
            // item.value = dayjs(item.value * 1000).tz(this.formData.zoneOffset).valueOf() / 1000
            item.value = item.value / 1000
          }
        })
      }
      if (this.isEdit) {
        res = await editActivityReq(this.formData)
      } else {
        res = await addActivityReq(this.formData)
      }
      if (res.code === 0) {
        this.$emit('input', false)
        this.$message.success('操作成功')
        this.$emit('rank')
      } else {
        this.$message.error(res.msg)
      }
    },
    // 删除条件
    delConditions(ind) {
      this.formData.joinModeInfo.conditions.splice(ind, 1)
    },
    // 新增条件
    addConditions() {
      this.formData.joinModeInfo.conditions.push({
        mode: '',
        relation: '',
        condition: '',
        value: ''
      })
    },
    parseActivity() {
      try {
        let data = JSON.parse(this.parseString)
        if (typeof data !== 'object') {
          this.$message.error('解析失败')
        } else {
          this.formData = data
          // 确保notJoinRidSet是字符串类型
          if (Array.isArray(this.formData.notJoinRidSet)) {
            this.formData.notJoinRidSet = this.formData.notJoinRidSet.join(',')
          } else if (this.formData.notJoinRidSet === null || this.formData.notJoinRidSet === undefined) {
            this.formData.notJoinRidSet = ''
          } else {
            this.formData.notJoinRidSet = String(this.formData.notJoinRidSet)
          }
          this.$message.success('解析成功')
          this.parseString = ''
        }
      } catch (error) {
        return this.$message.error('解析失败')
      }
    },
    handleClose() {
      this.$emit('input', false)
    },
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'event/model/img/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
  },
  async mounted() {
    const res1 = await getConstList('timeZone')
    const res2 = await getConstList('dateFormat')
    const res3 = await getChannelList()
    const res4 = await getCountryList()
    const res5 = await getConstList('joinMode')
    const res6 = await getConstList('conditionMode')
    const res7 = await getConstList('condition')
    const res8 = await getConstList('relation')
    const res9 = await getConstList('eventMode')
    const res10 = await getConstList('activityRankType')
    this.searchConst.channelList = res3;
    this.searchConst.countryList = res4;
    if (res1.code === 0 && res2.code === 0) {
      this.searchConst.zoneOffset = res1.data
      this.searchConst.dateFormat = res2.data
      this.searchConst.joinMode = res5.data
      this.searchConst.conditionMode = res6.data
      this.searchConst.condition = res7.data
      this.searchConst.relation = res8.data
      this.searchConst.eventMode = res9.data
      this.searchConst.rankType = res10.data
    }


    // const res3 = await getConstList('timeZone')
    // const res4 = await getConstList('timeZone')
    // const res5 = await getConstList('timeZone')
  }

}
</script>

<style scoped lang="scss">
.activity-drawer {
  &__contain {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .el-select {
    width: 100%;
  }

  &__main {
    flex: 1;
    margin: 0 20px;
    overflow: auto;

    .steps {
      display: flex;
      background-color: #f5f7fa;
      padding: 10px 0;
      color: #303133;
      font-size: 16px;
      margin-bottom: 16px;

      &__item {
        flex: 1;
        text-align: center;
        cursor: pointer;

        &.active {
          color: #409EFF;
        }
      }
    }
  }

  &__footer {
    display: flex;
    padding: 10px 10px 20px;

    >.el-button {
      flex: 1;
    }
  }
}

// 颜色选择
.color-suffix {
  display: flex;
  align-items: center;
  height: 100%;
}

// 删除图标
.ico-box {
  height: 40px;
  line-height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .ico {
    font-size: 20px;
    color: #ff0000;
    cursor: pointer;
  }
}

.btn-flex {
  display: flex;
  justify-content: flex-end;
  margin: 10px;
}

// 礼物弹窗样式
.gift-dialog {
  &__header {
    margin-bottom: 20px;
  }

  &__table {
    margin-bottom: 15px;
  }

  &__info {
    text-align: right;
    color: #666;
    font-size: 14px;
  }
}

.dialog-footer {
  text-align: right;
}
</style>